<template>
    <a class="--download-csv-a" @click="getModelCsv">
        <i class="fa-regular fa-arrow-down-to-line"></i>
        <span>Baixar arquivo modelo</span>
    </a>
</template>

<script>
import uploadService from '@/services/upload-service';

export default {
    name: 'download-csv',
    props: {
        resourceName: String,
        fileName: String,
        options: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        getModelCsv() {
            uploadService.getCsvModel(this.resourceName, this.fileName, this.options);
        }
    },
}
</script>

<style scoped>
.--download-csv-a {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #FF7A00;
    cursor: pointer;
}
</style>